// extracted by mini-css-extract-plugin
export default {"allButton":"Custom_allButton__qLz22","content":"Custom_content__qB-Rq","divider":"Custom_divider__zBAD5","button":"Custom_button__UqF7w"};